// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".modal-card[data-v-c7ec0836] {\n  height: 600px;\n}\n", ""]);
// Exports
module.exports = exports;
